
export const environment = {
  production: false,
  staging: true,
  isMockEnabled: true, // You have to switch this, when your real back-end is done
  authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',

  // ----------------- Staging ------------------------------------
  contratoApiUrl: 'https://contratostagingapi.viralwave.net/api/',
  staticFilesUrl: 'https://contratostagingapi.viralwave.net/',
  archivingStaticFilesUrl: 'https://contratostaging.viralwave.net/storage/',
  WebsiteUrl: 'https://contratostaging.viralwave.net/',
  clientId: '91a4046d-d8bb-465c-b07d-04d1fc1b8297',
  authority: 'https://login.microsoftonline.com/common',
  signalRUrl: 'https://contratostagingapi.viralwave.net/inform',
  password: "@@XX@@##Ct"

};
